'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { useLocale } from 'use-intl'
import Image from 'next/image'
import { useSliderCarousel } from '@/entities/image-slider/hooks'
import { langDir } from '@/shared/utils/directus'
import { IImage } from '@/interfaces/common'
import { Text } from '@/shared/ui'
import { SliderThumbs } from './ui/slider-thumbs'
import { SliderNavigation } from './ui/slider-navigation'
import style from './image-slider.module.scss'

interface ImageSliderProps extends HTMLProps<HTMLDivElement> {
  images: IImage[]
  description: string | null
  author: string | null
}

export const ImageSlider = (props: ImageSliderProps) => {
  const { className, images, description, author } = props
  const currentLocale = useLocale()
  const direction = (langDir[currentLocale] ?? 'ltr') as 'ltr' | 'rtl'
  const { onThumbClick, emblaThumbsRef, emblaMainRef, onNextButtonClick, onPrevButtonClick, selectedIndex } =
    useSliderCarousel(`.${style.slides}`, direction)

  return (
    <section className={clsx(style.container, className)}>
      <div className={style.wrapper} ref={emblaMainRef}>
        <ul className={clsx(style.slides)}>
          {images.map(image => (
            <li className={style.item} key={image.id}>
              <Image src={image.url} alt={image.title} fill style={{ objectFit: 'cover' }} />
            </li>
          ))}
        </ul>
        {description && <Text className={style.description} type="t2" color="dark" __html={description} />}
        {author && <Text className={style.author} type="t2" color="dark-040" __html={author} />}
        <SliderNavigation onNextButtonClick={onNextButtonClick} onPrevButtonClick={onPrevButtonClick} />
      </div>
      <SliderThumbs onThumbClick={onThumbClick} images={images} ref={emblaThumbsRef} selectedIndex={selectedIndex} />
    </section>
  )
}
